import { defineStore } from 'pinia';

import AnalysisService from '@/Analysis/analysis.service';

type AnalysisState = {};

export const useAnalysisActionsStore = defineStore('analysisActions', {
    state: (): AnalysisState => ({}),
    actions: {
        async deleteAnalysis(analysisId: string): Promise<void> {
            const analysisService = new AnalysisService();
            await analysisService.deleteAnalysisById(analysisId);
        },
    },
});
